import {
  Component,
  ViewChild,
  ViewContainerRef,
  ChangeDetectorRef,
  OnDestroy,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsComponent } from '../buttons/buttons.component';
import { BaseModalService } from 'src/utils/base-modal.service';

@Component({
  selector: 'app-base-modal',
  imports: [CommonModule, ButtonsComponent],
  templateUrl: './base-modal.component.html',
  styleUrl: './base-modal.component.scss',
})
export class BaseModalComponent implements OnDestroy {
  private readonly baseModalService = inject(BaseModalService);

  @ViewChild('modalContent', { read: ViewContainerRef })
  contentContainer!: ViewContainerRef;

  title = '';
  visible = false;
  showHeader = true;
  showFooter = true;
  confirmButtonText = 'Continuar';
  cancelButtonText = 'Cancelar';
  confirmButtonDisabled = false;
  width = '560px';
  customClass = '';
  confirmButtonType: any = 'primary';
  cancelButtonType: any = 'dark-borderless';
  zIndex = 50;
  showCancelButton = true;
  showConfirmButton = true;
  letEvents = false;

  closeFn?: () => void;
  confirmFn?: () => void;

  constructor(public readonly cdr: ChangeDetectorRef) {
    this.baseModalService.register(this);
  }

  ngOnDestroy(): void {
    this.baseModalService.unregister(this);
  }

  open() {
    this.visible = true;
    this.cdr.detectChanges();
  }

  close() {
    this.visible = false;
    this.closeFn?.();
  }

  confirm() {
    if (!this.confirmButtonDisabled) {
      this.confirmFn?.();
    }
  }

  stopPropagation(event: MouseEvent) {
    if (!this.letEvents) {
      event.stopPropagation();
    }
  }
}
